import { createAction, props } from '@ngrx/store';
import { IPMessage } from '../../models/pmessage.model';
import { ILoaderActionPayload } from '../models/loader.model';
import { CountryItem } from '../../../api/models';

export const mainActions = {
  login: createAction('main/login', props<{ message: IPMessage }>()),
  createMainMessage: createAction('main/createMessage', props<{ message: IPMessage }>()),
  uiUsersListAdvSearch: createAction('main/ui/users-list/adv-search', props<{ value: boolean }>()),
  uiCatalogueListAdvSearch: createAction('main/ui/catalogue/adv-search', props<{ value: boolean }>()),
  uiPaymentsListAdvSearch: createAction('main/ui/payments-list/adv-search', props<{ value: boolean }>()),
  uiCalendarAdvSearch: createAction('main/ui/calendar/adv-search', props<{ value: boolean }>()),
  uiEnrollmentsListAdvSearch: createAction('main/ui/enrollments-list/adv-search', props<{ value: boolean }>()),
  uiProceduresListAdvSearch: createAction('main/ui/procedures-list/adv-search', props<{ value: boolean }>()),
  uiMonitoringListAdvSearch: createAction('main/ui/monitoring-list/adv-search', props<{ value: boolean }>()),
  uiEventListAdvSearch: createAction('event/ui/monitoring-list/adv-search', props<{ value: boolean }>()),
};
